
import { History } from "lucide-react";
import { DrawingCard } from "./DrawingCard";
import { Separator } from "@/components/ui/separator";
import { Tables } from "@/integrations/supabase/types";

type Drawing = Tables<"whiteboard_history"> & {
  drawing_analyses?: {
    id: string;
    procedure_type: string;
    analysis_text: string;
    created_at: string;
    drawing_id: string;
    key_points: Json | null;
    status: "pending" | "completed" | "failed";
    updated_at: string;
    user_id: string;
  }[];
};

type Json =
  | string
  | number
  | boolean
  | null
  | { [key: string]: Json | undefined }
  | Json[]

interface LastUsedDrawingsProps {
  drawings: Drawing[];
  loadedImages: Set<string>;
  loadingDrawingId: string | null;
  onLoad: (id: string) => void;
  onDelete: (id: string) => void;
}

export function LastUsedDrawings({
  drawings,
  loadedImages,
  loadingDrawingId,
  onLoad,
  onDelete
}: LastUsedDrawingsProps) {
  if (drawings.length === 0) return null;

  return (
    <div className="mb-6">
      <div className="rounded-xl overflow-hidden bg-gradient-to-r from-muted/30 via-muted/20 to-transparent border border-border/30">
        <div className="flex items-center gap-2 px-4 py-3 border-b border-border/20 bg-muted/30 backdrop-blur-sm">
          <History className="h-4 w-4 text-primary/70" />
          <h3 className="text-sm font-medium text-foreground/80">Recently Used</h3>
        </div>
        <div className="grid grid-cols-4 gap-3 p-3">
          {drawings.map((drawing) => (
            <div key={drawing.id} className="transform transition-transform duration-200 hover:scale-105">
              <DrawingCard
                drawing={drawing}
                isImageLoaded={loadedImages.has(drawing.id)}
                loadingDrawingId={loadingDrawingId}
                onLoad={onLoad}
                onDelete={onDelete}
                isLastSaved={true}
              />
            </div>
          ))}
        </div>
      </div>
      <Separator className="my-6 opacity-30" />
    </div>
  );
}
